/* Scoped fallback for English classic-carousel chrome, NOT review translation.
 * Does not change ratings, review bodies, counts, or global Judge.me settings.
 * Respect custom app titles; only the known default is replaced. */
(() => {
  if (window.monoreeReleaseCopyInstalled) return;
  window.monoreeReleaseCopyInstalled = true;
  const titles = { lt: 'Klientų atsiliepimai', lv: 'Klientu atsauksmes', et: 'Klientide arvustused', pl: 'Opinie klientów', en: 'Let customers speak for us' };
  const watched = new WeakSet();
  const translatedCounts = new WeakMap();
  let scheduled = false;
  function update() {
    scheduled = false;
    const locale = (document.documentElement.lang || '').split('-')[0];
    document.querySelectorAll('.jdgm-carousel-wrapper').forEach((root) => {
      if (!watched.has(root)) {
        watched.add(root);
        new MutationObserver(schedule).observe(root, { childList: true, characterData: true, subtree: true });
      }
      const heading = root.querySelector('.jdgm-carousel-title');
      if (!heading || heading.children.length || !titles[locale]) return;
      const current = heading.textContent.trim();
      if (current === 'Let customers speak for us' || current === heading.dataset.monoreeTranslatedTitle) {
        if (current !== titles[locale]) heading.textContent = titles[locale];
        heading.dataset.monoreeTranslatedTitle = titles[locale];
      }
      // Translate only matching English text nodes in the header; preserve markup/count.
      const header = root.querySelector('.jdgm-carousel-title-and-link');
      if (!header) return;
      const walker = document.createTreeWalker(header, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (const node of nodes) {
        const prior = translatedCounts.get(node);
        const isEnglish = /^\s*from\s+[\d\s,.]+\s+reviews?\s*$/i.test(node.textContent);
        if (!isEnglish && node.textContent !== prior?.text) continue;
        const count = isEnglish ? node.textContent.match(/\d[\d\s,.]*/)?.[0].trim() : prior.count;
        if (!count) continue;
        const labels = { lt: `Atsiliepimų: ${count}`, lv: `Atsauksmes: ${count}`, et: `Arvustusi: ${count}`, pl: `Liczba opinii: ${count}`, en: `from ${count} reviews` };
        const next = labels[locale];
        if (node.textContent !== next) node.textContent = next;
        translatedCounts.set(node, { count, text: next });
      }
    });
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  // Observe added widgets, not all mutations on every page element indefinitely.
  const main = document.querySelector('main');
  if (main) new MutationObserver((entries) => {
    if (entries.some((entry) => [...entry.addedNodes].some((node) => node.nodeType === 1 &&
      (node.matches?.('.jdgm-carousel-wrapper') || node.querySelector?.('.jdgm-carousel-wrapper'))))) schedule();
  }).observe(main, { childList: true, subtree: true });
  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
